import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import React, { useState } from 'react'
import { Card, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import IgnoreForm from './IgnoreForm'
import IgnoredAlert from './IgnoredAlert'
import { useUpdateIssueLog } from 'api/hooks/use-issue-logs'
import { useQueryClient } from 'react-query'

function LogCard({ log }) {
  const queryClient = useQueryClient()
  const isIgnored = log.ignore_type !== null
  const isResolved = log.resolved_at !== null
  const [open, setOpen] = useState(false)
  const { mutate } = useUpdateIssueLog({
    params: {
      id: log.id,
      resolved_at: new Date().toISOString(),
      status: 'resolved'
    },
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries(['issue-logs'])
        queryClient.invalidateQueries([`issues/${log.municipality_issue_id}`])
      }
    }
  })

  return (
    <div className="mt-3">
      <Card className="mb-3 shadow-sm">
        <Card.Body>
          <div>
            <h5 className="mb-1">{log.details}</h5>
            <p className="text-muted small mb-0">
              Created On: {new Date(log.created_at).toLocaleString()}
            </p>
          </div>

          {isIgnored && (
            <IgnoredAlert
              log={log}
              isIgnored={isIgnored}
              isResolved={isResolved}
            />
          )}
          <div className="d-flex justify-content-start align-items-center mt-2">
            <Button
              variant="light"
              className={`me-2 ${isResolved ? 'bg-white' : ''}`}
              size="sm"
              onClick={() => {
                mutate()
              }}
              disabled={isResolved}
            >
              <FontAwesomeIcon
                icon={faCheckCircle}
                className={`me-2 ${isResolved ? 'text-success' : ''}`}
              />
              {isResolved
                ? `Resolved on ${new Date(log.resolved_at).toLocaleString()}`
                : 'Mark as Resolved'}
            </Button>
            {!isResolved && !isIgnored && (
              <IgnoreForm issueLogId={log.id} open={open} setOpen={setOpen} />
            )}
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

export default LogCard
